module.exports = __webpack_public_path__ + "img/pantalla-8-6.3d79f389.png";